import * as XLSX from 'xlsx';

export const exportToExcel = ({data=[],filename='example'}) => {
//   const data = [
//     { name: 'Apple', quantity: 10 },
//     { name: 'Banana', quantity: 5 },
//   ];
  let filenamenew = filename+'.xlsx';

  const worksheet = XLSX.utils.json_to_sheet(data);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Inventory');

  XLSX.writeFile(workbook, `${filenamenew}`);
};